
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/komodo-wallet/desktop",
      function () {
        return require("private-next-pages/en/komodo-wallet/desktop/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/komodo-wallet/desktop"])
      });
    }
  